import { PageNotFound } from '@common/pages/PageNotFound';
import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { usePermissions, useSession } from 'src/apps/invest/common/hooks';
import { AutoInvestmentsPage } from '../views/AutoInvestmentsPage';

const sessionRedirect = window.location.pathname;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

type AutoInvestmentsProps = {
  page?: 'main';
};

export const AutoInvestmentsController: React.FC<AutoInvestmentsProps> = ({ page = 'main' }) => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;
  }

  useEffect(() => {
    init();
  }, []);

  switch (page) {
    case 'main':
      return <AutoInvestmentsPage />;
    default:
      return <PageNotFound />;
  }
};
